package main.kotlin.data

open class DatabaseDocument(val id: String = "")
{

}
